import React from "react";
import { BadgeKeys, BadgeType } from "../constants/badgeTypes";
import GoogleIcon from "@/assets/images/google-icon.png";
import CommonImg from "@/components/Common/Img";
import { ItemSheetExtraTag } from "@/consts/Estimate";

interface BadgeProps {
  type: BadgeKeys;
  noLabel?: boolean;
}

const EstimateBadge: React.FC<BadgeProps> = ({ type, noLabel = false }) => {
  const { color, label } = BadgeType[type] ?? console.log(type);

  return (
    <div className="inline-flex items-center gap-2">
      <span
        className={`size-4 ${color} rounded-md shadow-md flex items-center justify-center`}
      >
        {type === ItemSheetExtraTag.GOOGLE_SEARCH ? (
          <CommonImg src={GoogleIcon} alt="G" />
        ) : (
          <span className="text-[8px] text-white font-semibold">
            {label.charAt(0)}
          </span>
        )}
      </span>
      {!noLabel && (
        <span className="text-[10px] text-gray-A font-semibold">{label}</span>
      )}
    </div>
  );
};

export default EstimateBadge;
